// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"9b70fbf6","488":"e2d94faa","796":"ebbc8abc"}[chunkId] + ".chunk.js";
};